import { useMutation, useQueryClient } from '@tanstack/react-query';
import { productApi } from '@entities/product';
import { useToast } from '@shared/ui';
import type { UUID } from '@shared/api';

export function useApproveProduct(id: UUID) {
  const qc = useQueryClient();
  const toast = useToast();
  return useMutation({
    mutationFn: () => productApi.approve(id),
    onSuccess: () => {
      toast.success('Товар опубликован');
      void qc.invalidateQueries({ queryKey: ['product', id] });
      void qc.invalidateQueries({ queryKey: ['products'] });
    },
    onError: (e: Error) => toast.error('Не удалось опубликовать', e.message),
  });
}

export function useRejectProduct(id: UUID) {
  const qc = useQueryClient();
  const toast = useToast();
  return useMutation({
    mutationFn: (reason: string) => productApi.reject(id, reason),
    onSuccess: () => {
      toast.success('Товар отклонён');
      void qc.invalidateQueries({ queryKey: ['product', id] });
      void qc.invalidateQueries({ queryKey: ['products'] });
    },
    onError: (e: Error) => toast.error('Не удалось отклонить', e.message),
  });
}
